import { BitrixVue, compile, h } from 'ui.vue3';
import { vplSiteStore } from '../../store/vplstore';
import { mapState } from 'ui.vue3.pinia';


export const HtmlComponent =
{
    props: {
        structKey: [String, Number],
        renderText: [Boolean],
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'textContent']),

    },
    methods: {
        getHtml(){
            if(this.renderText){
                return this.textContent;
            }else{
                return this.struct[this.structKey].content;
            }
        }
    },
    mounted(){
        let html = this.getHtml();
        if(html){
            let parsedContent = BX.processHTML(html);
            if(parsedContent.SCRIPT){
                for(let i in parsedContent.SCRIPT){
                    let scriptObj = parsedContent.SCRIPT[i];
                    scriptObj.JS = scriptObj.JS.replaceAll("get_json", "edit");
                    if(scriptObj.isInternal){
                        BX.evalGlobal(scriptObj.JS)
                    }else{
                        const scriptElement = document.createElement('script');
                        scriptElement.src = scriptObj.JS;
                        document.body.appendChild(scriptElement);
                    }
                }
            }
        }
    },
    template: `
        <div :style="{ display: 'contents'}" v-html="this.getHtml()"></div>
    `
    /*

        render() {
        return this.getHtml();
    }
    */
   /* render() {
        return compile(this.getHtml());
      }

      */
   /* template: `
    <teleport v-html="this.getHtml()"></teleport>
    `*/
}